import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {FileCard, Button, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-download'
};
var _$tmp1 = {
    'className': 'k-icon-download',
    'hoverable': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(FileCard, {
            'name': '品牌物料源文件.psd',
            'type': 'file',
            'byte': 1024 * 1024 * 58,
            'src': 'https://example.com/brand.psd',
            'showDelIcon': true,
            'style': {width: '220px'},
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['icon'] = function($super) {
                            return (
                                _$ce(2, 'div', 'PSD', 16, 'file-card-demo-custom-icon')
                            );
                        }),
                        (__$blocks['icon'] = function($super, data) {
                            var block = $blocks['icon'];
                            var callBlock = function() {
                                return _$blocks['icon'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['description'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'span', '58 MB', 16),
                                    _$cc(Button, {
                                        'icon': true,
                                        'type': 'none',
                                        'title': '下载',
                                        'className': 'file-card-demo-custom-download',
                                        'children': (
                                            _$cc(Icon, _$tmp0)
                                        )
                                    })
                                ], 4, 'file-card-demo-custom-description')
                            );
                        }),
                        (__$blocks['description'] = function($super, data) {
                            var block = $blocks['description'];
                            var callBlock = function() {
                                return _$blocks['description'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(FileCard, {
            'name': '概念海报.jpg',
            'type': 'file',
            'byte': 1024 * 512,
            'src': 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80',
            'showDelIcon': true,
            'style': {width: '220px'},
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['mask'] = function($super, media) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', '精选参考图', 16, 'file-card-demo-custom-mask-title'),
                                    _$cc(Button, {
                                        'size': 'small',
                                        'children': '查看详情'
                                    })
                                ], 4, 'file-card-demo-custom-mask', {
                                    'title': media.name
                                })
                            );
                        }),
                        (__$blocks['mask'] = function($super, data) {
                            var block = $blocks['mask'];
                            var callBlock = function() {
                                return _$blocks['mask'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(FileCard, {
            'name': '海边步道.jpg',
            'type': 'image',
            'src': 'https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=640&q=80',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['mask'] = function($super, media) {
                            return (
                                _$ce(2, 'div', [
                                    _$cc(Icon, {
                                        'className': 'k-icon-visible',
                                        'ev-click': media.preview,
                                        'hoverable': true
                                    }),
                                    _$cc(Icon, _$tmp1)
                                ], 4, 'file-card-demo-slots-mask')
                            );
                        }),
                        (__$blocks['mask'] = function($super, data) {
                            var block = $blocks['mask'];
                            var callBlock = function() {
                                return _$blocks['mask'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'file-card-demo-custom');
};